import { render, staticRenderFns } from "./ApproveModal.vue?vue&type=template&id=2e71fb82&scoped=true"
import script from "./ApproveModal.vue?vue&type=script&lang=js"
export * from "./ApproveModal.vue?vue&type=script&lang=js"
import style0 from "./ApproveModal.vue?vue&type=style&index=0&id=2e71fb82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e71fb82",
  null
  
)

export default component.exports